/******** rearrange test *********/
/**
 * Implementation:
 *  Use Theme editor to rearrange the sections
 * 
 */

const order = [
    "lp3_header_4mLXLe",
    "lp3_hero_yQYJ9j-1",
    "lp3_text_marquee_1_Ym4rxn",
    "lp3_featured_logos_hmePh6", // featured in
    "lp3_shop_section_fjps_variant_1_GdmhWX", // product section
    "lp3_customer_videos_adgJwU", // video
    "emc_faqs_Vn9kyj",// faq
    "pdp_icons_with_text_grid_F4UQFi",
    "lp3_reasons_N4DKcA", // 5 reasons why
    "us_vs_them_new_nLepKH", // us vs them
    "lp3_ingredients_3EwVNM",// premium ing
    "emc_text_marquee_34gdNz", // marquee
    "lp3_boost_wxEGMh", // coco boost
    "lp3_image_with_content_fxtAbK", // switch routine
    "lp3_comparison_Fi697k", // us vs them 2
    "lp3_steps_e8yMAK", // 3 steps
    "lp3_reviews_TFwchD", // reviews
    "clone-6",
    "lp3_image_with_text_3tnCyk", //  
    "emc_footer_7xRa7d" //
]

function rearrangeTest() {
    document.addEventListener("DOMContentLoaded", () => {
        const mainContainer = document.getElementById("MainContent");
        order.forEach(id => {
            let element;
            if(id.includes("clone")) {
                const index = Number(id.split("-")[1]);
                element = mainContainer.querySelector(`.shopify-section[id$="${order[index]}"]`).cloneNode(true);
                element.setAttribute("id", `${element.id}-cloned`);

                if(element.children.length) {
                    for(const child of element.children) {
                        if(child.id) child.setAttribute("id", `${child.id}-cloned`);
                    }
                }
                
            }else {
             element = mainContainer.querySelector(`.shopify-section[id$="${id}"]`);
            }
            mainContainer.append(element);
        });

        document.getElementById("customer-review").style.display = "";
    })
    
}

document.addEventListener("varify:23290", function() {
    console.log("varify:23290");
    rearrangeTest();

})


